import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Soufflage } from 'src/app/domain/Qualif/soufflage';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { ZoneCompare } from 'src/app/domain/Qualif/zone-compare';
import * as _ from 'lodash'

@Component({
    selector: 'app-zone-compare-box',
    templateUrl: './zone-compare-box.html',
    styleUrl: './zone-compare-box.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatSelectModule, FormsModule, MatOptionModule, MatInputModule, MatDatepickerModule, MatButtonModule, PreventDoubleClickDirective]
})
export class ZoneCompareBoxDialog implements OnInit {

    public Model: ZoneCompare = new ZoneCompare();
    diffPression: string = '';

    constructor(
        public dialogRef: MatDialogRef<ZoneCompareBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.Model = data;
        }
    }

    ngOnInit() { }

    checkCharacters(event: KeyboardEvent) {
        // var regex = /^\d+([.,]\d+)?$/g
        var regex = /-|\d|[.,]|Backspace|ArrowLeft|ArrowRight/g
        let success = regex.test(event.key)
        if (!success)
            event.preventDefault()
    }

    validCharacters() {
        // var regex = /^\d+([.,]\d+)?$/g
        var regex = /^-{0,1}\d+([.,]?\d+)?$/g
        let success = regex.test(this.diffPression)
        if (success)
            return true;
        return false;
    }

    canSave() {
        return this.diffPression !== undefined && this.Model.Name && this.validCharacters()
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        _.replace(this.diffPression!, ',', '.')
        this.Model.DifferentielPression = Number(this.diffPression)
        this.dialogRef.close(this.Model);
    }
}
